/**
 * Allied Brass Web Component Base Class
 * All interactive theme components extend this class.
 * Provides lifecycle hooks, section ID utility, and DOM query helpers.
 */
export class ABBaseComponent extends HTMLElement {
  /**
   * Called when element is added to DOM.
   * Subclasses override to set up event listeners, observers, etc.
   */
  connectedCallback() {
    // Override in subclass
  }

  /**
   * Called when element is removed from DOM.
   * Subclasses override to clean up listeners, observers, intervals.
   */
  disconnectedCallback() {
    // Override in subclass
  }

  /**
   * Get the Shopify section ID this component belongs to.
   * Used for Section Rendering API requests.
   * @returns {string|null}
   */
  get sectionId() {
    return this.closest('.shopify-section')?.id?.replace('shopify-section-', '') ?? null;
  }

  /**
   * Query a single element within this component.
   * @param {string} selector
   * @returns {Element|null}
   */
  $(selector) {
    return this.querySelector(selector);
  }

  /**
   * Query all matching elements within this component.
   * @param {string} selector
   * @returns {NodeList}
   */
  $$(selector) {
    return this.querySelectorAll(selector);
  }
}

/**
 * Safely register a custom element.
 * Guards against double-registration errors from Shopify Section Rendering API
 * which re-injects <script> tags when sections are re-rendered.
 * @param {string} name - Element name (must contain hyphen, e.g., 'ab-finish-picker')
 * @param {typeof HTMLElement} constructor - Component class
 */
export function defineComponent(name, constructor) {
  if (!customElements.get(name)) {
    customElements.define(name, constructor);
  }
}
